import { select } from '@ngneat/elf';
import { getAllAuditsOfferSupProposalDataSource, getAuditProposalSuppliersDataSource, getAuditsOfferSupFromProposalSupDataSource, getAuditsProposalSupplierDetails } from './audit-proposal-suppliers.requests';
import { auditProposalSuppliersStore } from './audit-proposal-suppliers.store';

export class AuditsProposalSuppliersQuery {
  store = auditProposalSuppliersStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  auditProposalSuppliers$ = getAuditProposalSuppliersDataSource.data$();
  auditsProposalSupplierDetails$ = getAuditsProposalSupplierDetails.data$();
  allAuditsOfferSupFromProposalSup$ = getAuditsOfferSupFromProposalSupDataSource.data$();
  allAuditsSupProposal$ = getAllAuditsOfferSupProposalDataSource.data$();

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const auditsProposalSuppliersQuery = new AuditsProposalSuppliersQuery();
